import { render, staticRenderFns } from "./campos-personalizados.vue?vue&type=template&id=27e26096"
import script from "./campos-personalizados.vue?vue&type=script&lang=js"
export * from "./campos-personalizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports